
export const laserDentistryData = {
  faqs: [
    {
      question: "What is laser dentistry?",
      answer: "Laser dentistry uses focused light beams to perform various dental procedures with greater precision and comfort. At Asrani Dental in Sadar, Nagpur, we use advanced dental lasers to treat gum disease, perform biopsies, remove decay, and more. This technology often replaces traditional tools like drills and scalpels for a more comfortable patient experience."
    },
    {
      question: "Is laser dentistry painful?",
      answer: "Laser dentistry is significantly less painful than traditional methods. In many cases at our Nagpur clinic, patients experience minimal discomfort and may not even need anesthesia for certain procedures. The laser seals nerve endings and blood vessels as it works, resulting in less bleeding, swelling, and post-operative pain."
    },
    {
      question: "What dental procedures can be performed with lasers?",
      answer: "At Asrani Dental in Sadar, Nagpur, we use lasers for many procedures including cavity detection and removal, gum reshaping, frenectomies, treating gum disease, teeth whitening, and treating cold sores. Lasers can also be used for biopsies and removing lesions. The specific procedures depend on your needs and the type of laser being used."
    },
    {
      question: "Is laser dentistry safe?",
      answer: "Yes, laser dentistry is very safe when performed by trained professionals like our team at Asrani Dental, Nagpur. Dental lasers are FDA-approved and have been used successfully for decades. They're precise, target only the areas that need treatment, and minimize damage to surrounding tissues. Protective eyewear is used during treatments to ensure complete safety."
    },
    {
      question: "What are the benefits of laser dentistry compared to traditional methods?",
      answer: "Laser dentistry offers numerous benefits including less pain (often eliminating the need for anesthesia), reduced anxiety for patients who fear dental drills, minimal bleeding and swelling, faster healing times, preservation of more healthy tooth structure, and reduced risk of bacterial infections since the laser sterilizes the area being treated."
    }
  ],
  testimonials: [
    {
      name: "Anita Desai",
      comment: "Having had both traditional and laser gum treatments at Asrani Dental in Nagpur, I can say the difference is remarkable. The laser procedure was quick, virtually painless, and I had almost no recovery time. Dr. Asrani explained everything thoroughly, and I'm thrilled with the results.",
      rating: 5
    },
    {
      name: "Mohan Kapoor",
      comment: "I've always been anxious about dental visits due to sensitivity issues. The laser cavity treatment I received at Asrani Dental in Sadar was a game-changer. No drill noise, no discomfort, and I was in and out quickly. The staff made the experience so comfortable I almost forgot I was at the dentist!",
      rating: 5
    },
    {
      name: "Priya Sharma",
      comment: "After struggling with persistent gum disease for years, the laser therapy at Asrani Dental Clinic in Nagpur has made a tremendous difference. The procedure was gentle, and I noticed improvement immediately. Three months later, my gums are healthier than they've been in a decade. I highly recommend their laser treatments.",
      rating: 5
    }
  ],
  services: [
    {
      title: "Laser Gum Treatment",
      description: "Advanced treatment for gum disease that disinfects and removes diseased tissue while promoting healing with minimal discomfort.",
      backgroundColor: "bg-white",
    },
    {
      title: "Cavity Detection & Removal",
      description: "Precise detection and removal of tooth decay with minimal impact on surrounding healthy tooth structure.",
      backgroundColor: "bg-[#F5F2EE]",
    },
    {
      title: "Laser Teeth Whitening",
      description: "Advanced whitening procedure using laser energy to enhance the action of whitening agents for dramatic, long-lasting results.",
      backgroundColor: "bg-[#E5DEFF]",
    },
    {
      title: "Gum Reshaping",
      description: "Precision contouring of gum tissue to improve the appearance of your smile or prepare for other cosmetic procedures.",
      backgroundColor: "bg-[#F7F5FF]",
    },
    {
      title: "Frenectomy",
      description: "Quick, comfortable treatment for tongue-tie and lip-tie conditions, improving speech and eating functions.",
      backgroundColor: "bg-[#EEFBF3]",
    },
    {
      title: "Soft Tissue Procedures",
      description: "Precise treatment for canker sores, cold sores, and removal of benign oral lesions with minimal discomfort.",
      backgroundColor: "bg-[#FFF8F0]",
    }
  ],
  benefits: [
    {
      title: "Minimally Invasive",
      description: "Laser treatments preserve more healthy tooth structure and reduce trauma to surrounding tissues."
    },
    {
      title: "Reduced Discomfort",
      description: "Many laser procedures require little or no anesthesia, with minimal pain during and after treatment."
    },
    {
      title: "Faster Healing",
      description: "Laser treatment promotes quicker recovery with less bleeding, swelling, and risk of infection."
    },
    {
      title: "Precision Treatment",
      description: "Lasers allow for incredible accuracy, targeting only the areas that need treatment while preserving healthy tissues."
    }
  ],
  relatedServices: [
    { name: "General Dentistry", path: "/services/general-dentistry-in-nagpur" },
    { name: "Cosmetic Dentistry", path: "/services/cosmetic-dentistry" },
    { name: "Painless RCT", path: "/services/painless-rct-in-nagpur" },
    { name: "Dental Implants", path: "/services/dental-implants-in-nagpur" },
    { name: "Wisdom Tooth Removal", path: "/services/wisdom-tooth-removal-nagpur" }
  ]
};
